import Map from './Map';
import formatPrice from '../helpers/FormatPrice';

class MapOverview extends Map {
  constructor(elem, locations, baseUrl) {
    super(elem, locations, 12);

    this.infoWindow = new window.google.maps.InfoWindow();

    this.placeFilter = document.querySelector('.js-map-place-filter');

    this.baseUrl = baseUrl;
    this.goToPlace = this.goToPlace.bind(this);

    this._setDOMReferences();
  }

  _setDOMReferences() {
    if (this.placeFilter) {
      this.placeFilter.addEventListener('change', this.goToPlace);
    }
  }


  goToPlace() {
    window.location.href = `${this.baseUrl}?Woonplaats=${this.placeFilter.value}`;
  }

  createMarker(location, type, icon, obj) {
    const marker = new window.google.maps.Marker({
      map: this.map,
      position: location,
      icon: icon,
    });

    this.markers[type].push(marker);

    const self = this;

    window.google.maps.event.addListener(marker, 'click', function () {
        let priceWindow = "";
        let surfaceAndRoomsWindow = "";
        if(obj.price) {
            priceWindow = '<div class="infowindow__price">' +
                (obj.pricePrefix ? obj.pricePrefix + " " : "") +
                "<span>" +
                formatPrice(obj.price) +
                (obj.priceCondition ? " " + obj.priceCondition : "") +
                "</span>" +
                "</div>";
        }
        if(obj.surface && obj.rooms) {
            surfaceAndRoomsWindow = '<div class="infowindow__description"><p>' +
                obj.surface +
                ' m<sup>2</sup> &bull; ' +
                obj.rooms + ' kamers</p></div>';
        }
      const contentString =
        '<a href="' + obj.link + '">' +
        '<figure class="infowindow__figure">' +
        '<img class="infowindow__image" src="' +
        obj.image +
        '" />' +
        "</figure>" +
        "</a>" +
        '<div class="infowindow__inner">' +
        '<div class="infowindow__title">' +
        obj.address +
        "</div>" +
        priceWindow +
        surfaceAndRoomsWindow +
        '<a href="' + obj.link + '" class="button button--full">Bekijk ' +
        obj.objectType +
        '</a>' +
        "</div>";

      self.infoWindow.setContent(contentString);
      self.infoWindow.open(this.map, this);
    });

    this.bounds.extend(location);
  }
}

export default MapOverview;
